<script>
  export default {
    name: 'LoadingIndicator'
  }
</script>

<template>
  <div class="vc-loading-indicator animated bounceInDown">
    <VBtn icon small class="vc-loading-indicator__btn">
      <VProgressCircular indeterminate color="accent" size="24" width="4"/>
    </VBtn>
  </div>
</template>

<style scoped>
  .vc-loading-indicator {
    position: absolute;
    top: -24px;
    left: 50%;
    z-index: 9999;
    transform: translateX(-12px);
  }
  .vc-loading-indicator__btn {
    background: #CCC;
    box-shadow: 0 0 3px rgba(32, 32, 32, 1);
  }
</style>
